export const CONSTANT_ACCOUNT_MIGRATION = {
    // Account Migration constants
    NEW_ACCOUNT_REQUEST: 'Request Account Migration',
    ACCOUNT_MIGRATION_STATUS: 'Account Migration Status',
    ACCOUNT_STATUS: 'Account Status',
    FALCON_INSTANCE_ID: 'Falcon Instance ID',
    FALCON_INSTANCE_ID_PLACEHOLDER: 'Enter the Falcon Instance ID here',
    FALCON_DOMAIN_ID: 'Falcon Domain ID',
    FALCON_DOMAIN_ID_PLACEHOLDER: 'Enter the Falcon Domain ID here',
    TARGET_OU: 'Target Org Unit',
    FALCON_MPA: 'Falcon MPA',
    ACCOUNT_ID: 'Account ID',
    ACCOUNT_NAME: 'Account Name',
    SERVICE_TEAM_ID: 'Service Team ID',
    MPA_NAME: 'Target Master Payer Account',
    MPA_NAME_PLACEHOLDER: 'Select a Master Payer account',
    OU_ID: 'Org Unit ID',
    OU_ARN_PLACEHOLDER: 'Select Org Unit where the account should be created',
    CHECK_STATUS: 'Check Status',
    PROCESSING: 'Processing',
    SUCCESS: 'Success',
    FAILURE: 'Failure',
    NOT_FOUND: 'Not Found',
    ERROR: 'Error',
    MANUAL_APPROVAL: 'Manual Approval',
    ACCOUNT_ID_PLACEHOLDER: 'Enter the account ID here',
    APPROVE_BUTTON: 'Approve',
    REJECT_BUTTON: 'Reject',
    // Progress Stages
    ROLLBACK: 'Rollback',
    ACCOUNT_MOVEMENT: 'Account Movement',
    WAIT_FOR_APPROVAL: 'Wait for Approval',
    PROVISIONING: 'Provisioning',
    OVERALL_STATUS: 'Overall Status',
    CURRENT_STEP: 'Current Step'
};
